import { z } from 'zod';
export const TriggerOrderDoneEventSchema = z.object({
    orderId: z.string().uuid(),
});

export type TriggerOrderDonePayload = z.infer<typeof TriggerOrderDoneEventSchema>;
